import { Empty, Table } from 'antd';
import type { ColumnsType, TableProps } from 'antd/es/table';
import InfiniteScroller from 'components/molecules/InfiniteScroller';
import { CALENDAR_TABLE_HEIGHT_OFFSET } from '../../config/calendarConstants';

export interface MetricTableProps<T extends { id?: string; key?: string; attributeExId?: string; kpi_id?: string }> {
    dataSource: T[];
    columns: ColumnsType<T>;
    isPending: boolean;
    isFetching: boolean;
    isFetchingNextPage: boolean;
    hasNextPage: boolean;
    fetchNextPage: () => void;
    handleTableChange: (pagination: unknown, filters: unknown, sorter: any) => void;
    rowKey?: keyof T | ((row: T) => string);
    emptyDescription?: string;
    rowSelection?: TableProps<T>['rowSelection'];
    height?: number;
}

function MetricTable<T extends { id?: string; key?: string; attributeExId?: string; kpi_id?: string }>({
    dataSource,
    columns,
    isPending,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    handleTableChange,
    rowKey,
    emptyDescription,
    rowSelection,
    height,
}: MetricTableProps<T>) {
    const resolveKey: any =
        rowKey ??
        ((row: T) => row.id ?? row.kpi_id ?? row.attributeExId ?? row.key ?? Math.random().toString(36).slice(2));

    const scrollerHeight = height ?? window.innerHeight - CALENDAR_TABLE_HEIGHT_OFFSET;

    return (
        <div className="">
            <InfiniteScroller
                data={dataSource}
                onNext={fetchNextPage}
                hasMore={hasNextPage}
                loading={isFetchingNextPage}
                height={scrollerHeight}
            >
                <Table<T>
                    className="planner-metric-table"
                    rowKey={resolveKey}
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    scroll={{ x: 'max-content' }}
                    loading={isPending || isFetching || isFetchingNextPage}
                    sticky
                    bordered
                    onChange={handleTableChange}
                    rowSelection={rowSelection}
                    locale={{
                        emptyText: <Empty description={emptyDescription ?? 'No data'} />,
                    }}
                />
            </InfiniteScroller>
        </div>
    );
}

export default MetricTable;
